import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'
import MessagesContent from "./MessagesContent";
export default class Messages extends Component {
  render() {
    let page = this.props.match.params.page;

    const urlParams = new URLSearchParams(window.location.search);

    return (
      <div class="wrapper">
        <Navbar />
        <Mainmenu />
        <MessagesContent urlParams={urlParams} page={page} />
        <Footer />
      </div>
    );
  }
}
